// extracted by mini-css-extract-plugin
export default {"wrapper":"content_wrapper__j3k2k","stateBadge":"content_stateBadge__XfpO2","outro":"content_outro__o-rII","dot":"content_dot__LTvpo"};